module.exports = __webpack_public_path__ + "wireframe1.png?8720427794ab6e28262a0ca95d3bec55";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/wireframe1.png
// module id = 235
// module chunks = 0